import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { SharedUtilsDirectivesModule } from 'libs/shared/utils/directives/src'
import { GbMascotSuccessComponent } from './gb-mascot-success/gb-mascot-success.component'
import { GbTimerComponent } from './gb-timer/gb-timer.component'
import { MatCardModule } from '@angular/material/card'

import { TranslateModule } from '@ngx-translate/core'
import { MatIconModule } from '@angular/material/icon'
import { GbCalloutComponent } from './gb-callout/gb-callout.component'
import { GbLoadingSpinnerComponent } from './gb-loading-spinner/gb-loading-spinner.component'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { MatDialogModule } from '@angular/material/dialog'
import { GbIntlPhoneInputComponent } from './gb-intl-phone-input/gb-intl-phone-input.component'
import { MatInputModule } from '@angular/material/input'
import { MatMenuModule } from '@angular/material/menu'
import { MatButtonModule } from '@angular/material/button'
import { MatDividerModule } from '@angular/material/divider'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { SharedUtilsPipesModule } from 'libs/shared/utils/pipes/src'
import { GbItemSearchComponent } from './gb-item-search/gb-item-search.component'
import { GbItemsObserverComponent } from './gb-items-observer/gb-items-observer.component'
import { GbAlertBoxComponent } from './gb-alert-box/gb-alert-box.component'
import { GbMascotComponent } from './gb-mascot/gb-mascot.component'
import { GbQuillTextComponent } from './gb-quill-text/gb-quill-text.component'
import { GbMastercardIconComponent } from './gb-mastercard-icon/gb-mastercard-icon.component'
import { GbAmexIconComponent } from './gb-amex-icon/gb-amex-icon.component'
import { GbVisaIconComponent } from './gb-visa-icon/gb-visa-icon.component'
import { GbGooglePayIconComponent } from './gb-google-pay-icon/gb-google-pay-icon.component'
import { GbApplePayIconComponent } from './gb-apple-pay-icon/gb-apple-pay-icon.component'
import { GbRangeSliderComponent } from './gb-range-slider/gb-range-slider.component'
import { GbTipIconComponent } from './gb-tip-icon/gb-tip-icon.component'
import { GbStripeIconComponent } from './gb-stripe-icon/gb-stripe-icon.component'
import { GbSkeletonLoaderComponent } from './gb-skeleton-loader/gb-skeleton-loader.component'
import { GbPasswordHintComponent } from './gb-password-hint/gb-password-hint.component'
import { GbPoweredByStripeComponent } from './gb-powered-by-stripe/gb-powered-by-stripe.component'
import { GbCheckInInstructionsComponent } from './gb-check-in-instructions/gb-check-in-instructions.component'
import { GbPaymentPendingComponent } from './gb-payment-pending/gb-payment-pending.component'
import { GbFilterChipsComponent } from './gb-filter-chips/gb-filter-chips.component'
import { MatChipsModule } from '@angular/material/chips'

@NgModule({
  imports: [
    CommonModule,
    SharedUtilsDirectivesModule,
    TranslateModule,
    MatCardModule,
    MatIconModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    FormsModule,
    MatInputModule,
    MatMenuModule,
    MatButtonModule,
    MatDividerModule,
    ReactiveFormsModule,
    SharedUtilsPipesModule,
    MatChipsModule,
  ],
  declarations: [
    GbMascotSuccessComponent,
    GbTimerComponent,
    GbCalloutComponent,
    GbLoadingSpinnerComponent,
    GbIntlPhoneInputComponent,
    GbItemSearchComponent,
    GbItemsObserverComponent,
    GbAlertBoxComponent,
    GbMascotComponent,
    GbQuillTextComponent,
    GbMastercardIconComponent,
    GbAmexIconComponent,
    GbVisaIconComponent,
    GbGooglePayIconComponent,
    GbApplePayIconComponent,
    GbRangeSliderComponent,
    GbTipIconComponent,
    GbStripeIconComponent,
    GbSkeletonLoaderComponent,
    GbPasswordHintComponent,
    GbPoweredByStripeComponent,
    GbCheckInInstructionsComponent,
    GbPaymentPendingComponent,
    GbFilterChipsComponent,
  ],
  exports: [
    GbMascotSuccessComponent,
    GbTimerComponent,
    GbCalloutComponent,
    GbLoadingSpinnerComponent,
    GbIntlPhoneInputComponent,
    GbItemsObserverComponent,
    GbAlertBoxComponent,
    GbMascotComponent,
    GbQuillTextComponent,
    GbMastercardIconComponent,
    GbAmexIconComponent,
    GbVisaIconComponent,
    GbGooglePayIconComponent,
    GbApplePayIconComponent,
    GbRangeSliderComponent,
    GbTipIconComponent,
    GbStripeIconComponent,
    GbSkeletonLoaderComponent,
    GbItemSearchComponent,
    GbPasswordHintComponent,
    GbPoweredByStripeComponent,
    GbCheckInInstructionsComponent,
    GbPaymentPendingComponent,
    GbFilterChipsComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedUiModule {}
